function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("symbol", {
  id: "Logo",
  "data-name": "Logo",
  viewBox: "0 -30 1050 1050"
}, React.createElement("path", {
  d: "M450.2 177.4c-44.35-99.8-64-157-56.64-169.58 6.57-11.16 206.71-9.31 212.72-1.12 8.2 16.77-63.4 155.24-100.86 219.92-19.42 33.56-18.59 33.22-55.22-49.22Z",
  stroke: "black",
  strokeWidth: 30
}), React.createElement("path", {
  d: "M692.53 315.33c.57-435.95-208-297.3 282.41-233.92C1024 204.1 829.4 413.69 702.68 475.15c-49.12 32.56-10.23-96.75-10.15-159.82ZM.32 149.45c-6.72-12.24 95.62-40.07 146.25-64.6C203.51 68 274.25 35.25 318.46 23.63c40.48-10.88 37.4-1.18 18.64 42.87-19.3 57.5-37.83 141.46-45.38 201-9.42 64.87-5.83 127.39 8.69 191.9 14.56 29.36-9 21.95-30.46 12.78C132.94 402.8 61.52 261 .32 149.45ZM835.67 882c-34.26-51.47-29.63-99-50-159.17-7.1-21-24.57-37.48-49.1-60.26-35.74-33.18-108.71-71.76-104.05-78.12 7.37-10 118.93-5.2 176.64 5.67 93.41 17.59 115.74 21.34 163.43 96.55l26.46 39.58c6.29 8.98-101.29 126.38-163.38 155.75ZM792 916.87c9.63 21.56-182 88.42-235.06 89.13C433.76 1007.65 77 865.86 99.29 827.5c11.22-19.36 154-241.23 175.59-238.21 23.53 3.29 84.26 245.6 177.16 332.27 15.17 14.15 31.2 34.62 50.48 33.21 15.08-1.11 70.36-108 102.64-164.19 14.88-25.89 37.43-81.19 61.49-84.47C684.31 703.69 750 858.48 792 916.87Z",
  stroke: "black",
  strokeWidth: 30
})), React.createElement("symbol", {
  id: "icon-fg",
  "data-name": "icon-fg",
  viewBox: "0 0 676.95 681"
}, React.createElement("use", {
  xlinkHref: "#Logo",
  width: 999.33,
  height: 1006.01,
  transform: "matrix(.68 0 0 .68 .5 .5)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#icon-fg",
  width: 676.95,
  height: 681,
  transform: "translate(163.11 186)"
});

var SvgGrsly = function SvgGrsly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGrsly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grsly.b3a34256.svg";
export { ForwardRef as ReactComponent };